/* Tiny logger that's a no-op in production builds.
 * Use instead of bare console.* for non-critical admin / debug logs. */
const isDev = process.env.NODE_ENV !== "production";

export const devLog = {
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  // .error is still surfaced in production · admins want stack traces
  // when something genuinely breaks; but route everything through the
  // logger so we can swap in Sentry/LogRocket later in one place.
  error: (...args) => { console.error(...args); },
};

export default devLog;
